// Theme configuration with essential colors only
export const themes = {
  light: {
    // Primary colors
    primary: '#3b82f6',      // Blue-500
    primaryHover: '#2563eb', // Blue-600
    primaryLight: '#dbeafe', // Blue-100
    
    // Secondary colors
    secondary: '#6b7280',    // Gray-500
    secondaryHover: '#4b5563', // Gray-600
    
    // Background colors
    bg: '#ffffff',           // White
    bgSecondary: '#f9fafb',  // Gray-50
    bgTertiary: '#f3f4f6',   // Gray-100
    
    // Sidebar colors (light mode - lighter sidebar)
    sidebarBg: '#f8fafc',    // Slate-50
    sidebarText: '#334155',  // Slate-700
    sidebarTextMuted: '#64748b', // Slate-500
    sidebarHover: '#e2e8f0', // Slate-200
    
    // Text colors
    text: '#111827',         // Gray-900
    textSecondary: '#6b7280', // Gray-500
    textMuted: '#9ca3af',    // Gray-400
    textInverse: '#ffffff',  // White
    
    // Border colors
    border: '#e5e7eb',       // Gray-200
    borderLight: '#f3f4f6',  // Gray-100
    
    // Status colors
    success: '#22c55e',      // Green-500
    warning: '#f59e0b',      // Amber-500
    error: '#ef4444',        // Red-500
  },
  
  dark: {
    // Primary colors
    primary: '#3b82f6',      // Blue-500
    primaryHover: '#60a5fa', // Blue-400
    primaryLight: '#1e3a8a', // Blue-900
    
    // Secondary colors
    secondary: '#9ca3af',    // Gray-400
    secondaryHover: '#d1d5db', // Gray-300
    
    // Background colors
    bg: '#111827',           // Gray-900
    bgSecondary: '#1f2937',  // Gray-800
    bgTertiary: '#374151',   // Gray-700
    
    // Sidebar colors
    sidebarBg: '#0f172a',    // Slate-900
    sidebarText: '#e2e8f0',  // Slate-200
    sidebarTextMuted: '#94a3b8', // Slate-400
    sidebarHover: '#1e293b', // Slate-800
    
    // Text colors
    text: '#f1f5f9',         // Slate-100
    textSecondary: '#cbd5e1', // Slate-300
    textMuted: '#94a3b8',    // Slate-400
    textInverse: '#0f172a',  // Slate-900
    
    // Border colors
    border: '#334155',       // Slate-700
    borderLight: '#475569',  // Slate-600
    
    // Status colors
    success: '#22c55e',      // Green-500
    warning: '#f59e0b',      // Amber-500
    error: '#ef4444',        // Red-500
  }
};

// Color schemes for different primary colors
export const colorSchemes = {
  blue: {
    primary: '#3b82f6',
    primaryHover: '#2563eb',
    primaryLight: '#dbeafe',
    textInverse: '#ffffff', // White text on blue background
  },
  indigo: {
    primary: '#6366f1',
    primaryHover: '#4f46e5',
    primaryLight: '#e0e7ff',
    textInverse: '#ffffff', // White text on indigo background
  },
  purple: {
    primary: '#a855f7',
    primaryHover: '#9333ea',
    primaryLight: '#e9d5ff',
    textInverse: '#ffffff', // White text on purple background
  },
  violet: {
    primary: '#816acf',
    primaryHover: '#816acf',
    primaryLight: '#ddd6fe',
    textInverse: '#ffffff', // White text on violet background
  },
  green: {
    primary: '#22c55e',
    primaryHover: '#16a34a',
    primaryLight: '#dcfce7',
    textInverse: '#000000', // White text on green background
  },
  orange: {
    primary: '#f97316',
    primaryHover: '#ea580c',
    primaryLight: '#fed7aa',
    textInverse: '#ffffff', // White text on orange background
  },
};

export type ThemeMode = 'light' | 'dark';
export type ColorScheme = keyof typeof colorSchemes;
export type Theme = typeof themes.light;

// Default theme configuration
export const defaultTheme = {
  mode: 'light' as ThemeMode,
  colorScheme: 'violet' as ColorScheme,
};
